import { CATEGORIES_SETUP } from '../constants';

const girlSetup = CATEGORIES_SETUP['d4dddbb7-78b1-4704-b5d8-c51eebf92d01'];

export const getMostPreferredCategory = (userCategories: string[]) => {
  const categoriesWithPriorities = userCategories.filter((userCategory) => {
    return (
      userCategory in CATEGORIES_SETUP &&
      CATEGORIES_SETUP[userCategory].priority > 1
    );
  });

  const sortedCategoriesWithPriorities = categoriesWithPriorities.sort(
    (a, b) => {
      return CATEGORIES_SETUP[a].priority > CATEGORIES_SETUP[b].priority
        ? -1
        : 1;
    },
  );

  const theMostPrioritizedCategory = sortedCategoriesWithPriorities[0];

  return CATEGORIES_SETUP[theMostPrioritizedCategory] || girlSetup;
};
